import { render } from "./FailedTransfersPerStatusDescriptionChartContainer.vue?vue&type=template&id=584e0e88"
import script from "./FailedTransfersPerStatusDescriptionChartContainer.vue?vue&type=script&lang=js"
export * from "./FailedTransfersPerStatusDescriptionChartContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__